import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Tabs from 'react-bootstrap/lib/Tabs';
import Tab from 'react-bootstrap/lib/Tab';
import { Route } from 'react-router-dom';
import { Col, Row } from 'react-bootstrap';

import {
  _getKeyFromHash,
  _passwordRunPage,
  _tokenRunPage,
  _topicPasswordPage,
  _refreshHandler
} from './../helpers/cloudhelpers.js';

export default class CloudTabComponent extends Component {
  static propTypes = {
    acquisitions: PropTypes.array,
    buildNumber: PropTypes.number,
    timestamp: PropTypes.string
  };

  constructor(props) {
    super(props);
    this.state = {
      activeKey: _getKeyFromHash(window.location.hash),
      show: true
    };
  }

  componentDidMount() {
    window.addEventListener('hashchange', function (e) {
      this.setState({ activeKey: _getKeyFromHash(e.srcElement.location.hash) });
    }.bind(this));
  }

  render() {
    return (
      <div>
        <Col sm={14} md={10} mdOffset={1} style={{ zIndex: 0 }}>
          <Row style={{ marginBottom: '15px' }}>
            <Col xs={14}>
              <Tabs activeKey={this.state.activeKey}
                onSelect={_refreshHandler.bind(this)}
                id="Nightly Acquisition Tabs"
                ref={tabs => {
                  this.target = tabs;
                }}
              >
                <Tab eventKey={1} title="Password Runs">
                  {['/cloud', 'cloud/passwordRuns'].map((path, index) =>
                    <Route path={path} key={index}
                      render={() => _passwordRunPage(this.props.acquisitions)}
                    />
                  )}
                </Tab>
                <Tab eventKey={2} title="Token Runs">
                  <Route path="/cloud/tokenRuns"
                    render={() => _tokenRunPage(this.props.acquisitions)}
                  />
                </Tab>
                <Tab eventKey={3} title="Topic Password Runs">
                  <Route path="/cloud/topicPasswordRuns"
                    render={() => _topicPasswordPage()}
                  />
                </Tab>
              </Tabs>
            </Col>
          </Row>
        </Col>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// src/Components/CloudTabComponent.jsx